import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/Vuetify/vuetify";
import router from "./router";
import store from "./store";
import { http, httpmdc, httpmdconstruction } from "./plugins/Axios";
import VeeValidate from "./plugins/VeeValidate";
import VueIcon from "./plugins/VueIcon";
import VueNotifications from "vue-notification";
import i18n from "./plugins/I18n";
import { can } from "@/plugins/Casl";
import configuration from "./configuration";
import "@dt-ecosystem/ui/packages/vue2/dist/style.css";
import moment from "moment";
import "./assets/css/a_style.css";
import "./assets/css/my_style.css";
import TokenService from "@/services/TokenService";
import "vue-tour/dist/vue-tour.css";
import { addTimeZoneToISOString } from "@/utils/pureFunctions";
import "leaflet/dist/leaflet.css";
addTimeZoneToISOString();

import wb from "./registerServiceWorker";

Vue.prototype.$workbox = wb;
Vue.use(can);
import VueTour from "vue-tour";
window.moment = moment;
Vue.use(VueNotifications);
Vue.use(configuration);
Vue.prototype.$http = http;
Vue.prototype.$httpmdc = httpmdc;
Vue.prototype.$httpmdconstruction = httpmdconstruction;
Vue.use(VueIcon);
Vue.use(VeeValidate);
Vue.use(VueTour);
Vue.config.productionTip = false;

(async function () {
  const token = TokenService.getToken();
  if (token) {
    try {
      await store.dispatch("getUser");
    } catch (e) {
      console.log(e);
    }
  }
  document.getElementById("initial-load-wrap").remove();
  new Vue({
    vuetify,
    store,
    router,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
})();
